import { EventConstants } from "../EventConstants";

/**
 * Adds an event to an element to on pressing the enter key, trigger the click of a button element.
 * @param triggerSelector The selector for the element to add the key down event to.
 * @param targetSelector The button element selector.
 * @param validator An optional validation function to call, to determine if the button should be clicked or not.
 */
export const applyEnterButtonTarget = (triggerSelector: string, targetSelector: string, validator?: () => boolean) => {

	$(triggerSelector).off(EventConstants.keydown_ipf).on(EventConstants.keydown_ipf, event => {

		// handle the enter key being pressed
		if (event.key === EventConstants.key_enter) {

			// if there is no validator function or it doesn't return false explicitly, trigger the click
			if (!validator || validator() !== false) {
				$(targetSelector).click();
			}
			event.preventDefault();
		}
	});
}